import React from 'react'
import purpleImg from '../../../assets/images/home/fondo-morado.svg'
import './learnPuberty.scss'

function LearnPuberty() {
  return (
    <div className="f-learn-puberty">
      <div className="f-learn-puberty__wrapper">
        <div className="f-learn-puberty__image">
          <img src={purpleImg} alt="personajes nosotras" />
        </div>
        <div className="f-learn-puberty__text">
          <h2>Aprende sobre</h2>
          <h3>
            La pubertad con <span />
          </h3>
          <p>
            Aquí tendrás todo el contenido educativo que necesites para aprender
            de manera divertida y dinámica sobre la pubertad, el ciclo
            menstrual, la Zona V y los productos Nosotras perfectos para cada
            etapa.
          </p>
        </div>
      </div>
    </div>
  )
}

export default LearnPuberty
